import {
  GetDashboardUrlRequest,
  GetDashboardUrlResponse,
} from './external-reports.interface';
import { convertQueryRequestToQueryParams } from 'functions/convertObjectToUrlParam';
import { apiService } from 'store/api';

export const externalReportsService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardUrl: builder.query<
      GetDashboardUrlResponse,
      GetDashboardUrlRequest
    >({
      query: (request) => ({
        url: `/external-reports/dashboard-url/${
          request.dashboardId
        }?${convertQueryRequestToQueryParams({
          params: request.params,
        })}`,
        method: 'GET',
      }),
    }),
  }),
});
